export default "__VITE_ASSET__CGZYHFK3__"